import React from "react";
import { useIntl } from "react-intl";
import { SimpleEntityGrid } from "../../../../components/grid/SimpleEntityGrid";
import { SiteTransport } from "../../../../transports/site";
import { UpsertSiteDTOSchema } from "../../../../types/Site";
import useSiteGridAnalyzeColumns from "./useSiteGridAnalyzeColumns";
import useSiteGridAnalyzeToolbarButtons from "./useSiteGridAnalyzeToolbarButtons";

export const SiteGridAnalyze: React.FC = () => {
    const { formatMessage } = useIntl();

    const gridColumns = useSiteGridAnalyzeColumns();

    const toolActionsButton = useSiteGridAnalyzeToolbarButtons();

    return (
        <>
            <SimpleEntityGrid
                entityName={formatMessage({ id: "common.entity.site" })}
                columns={gridColumns}
                formBody={() => <></>}
                listHandler={SiteTransport.listTraffic}
                saveHandler={() => {}}
                toolbarButtonAction={toolActionsButton}
                validationSchema={UpsertSiteDTOSchema}
            />
        </>
    );
};
